/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Turnstile_UnavailableInputs */

const en_error_turnstile_unavailable = /** @type {(inputs: Error_Turnstile_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We can't check that you're a person right now. Try again in a few minutes.`)
};

/**
* | output |
* | --- |
* | "We can't check that you're a person right now. Try again in a few minutes." |
*
* @param {Error_Turnstile_UnavailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_turnstile_unavailable = /** @type {((inputs?: Error_Turnstile_UnavailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Turnstile_UnavailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_turnstile_unavailable(inputs)
});